import { ReactNode } from "react";

type ModalProps = {
  children?: ReactNode; // Optional children prop
  // onClose: () => void; // Function to close the modal
};

export default function Modal({ children }: ModalProps) {

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-opacity-50 z-50">
      <div className="relative w-full max-w-lg mx-4 p-6 rounded-lg shadow-lg">
        {children}
      </div>
    </div>
  );
}
